import type { FeedbackMessages } from './en';

const zh: FeedbackMessages = {
  qualified: {
    title: '感谢您完成本次研究！',
    body1: '您现在可以关闭浏览器窗口。',
    body2: '我们期待很快再次见到您。',
    refCode: '参考代码：{code}',
  },
  quotaFull: {
    title: '本次研究已结束',
    body1: '感谢您对我们研究的关注。',
    body2: '很遗憾，我们已收到所需的全部回复。',
    body3: '希望在我们未来的研究中能与您相见！',
    refCode: '参考代码：{code}',
  },
  terminated: {
    title: '感谢您分享您的反馈！',
    body1: '我们期待在未来的研究中很快再次见到您。在此之前，祝您有美好的一天。',
    body2: '请关闭此浏览器窗口。',
    refCode: '参考代码：{code}',
  },
  mismatch: {
    title: '感谢您的关注',
    body1: '很遗憾，您不属于本次特定研究的目标群体。',
    body2: '您可以关闭此页面。',
    code: '代码：{code}',
  },
  error: {
    title: '我们无法处理您的请求',
    linkProblemDetailed:
      '您所访问的链接出现问题。请检查地址栏中的链接是否与提供给您的链接一致，然后重试。',
    linkProblemGeneric: '您所访问的链接出现问题。请重试。',
    contactPerson: '如果问题持续存在，请告知向您提供该链接的人此问题。',
    errorCode: '错误代码：{code}',
  },
};

export default zh;
